import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation, useParams } from 'react-router-dom';
// @mui
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
// iconify
import { Icon } from '@iconify/react';
import homeFill from '@iconify/icons-eva/home-fill';
import bookOpenFill from '@iconify/icons-eva/book-open-fill';
import personFill from '@iconify/icons-eva/person-fill';

// ----------------------------------------------------------------------

// redux
import { useDispatch, useSelector } from 'src/redux/store';
import { getShopSettings } from 'src/redux/slices/shops';
// hooks
import { ShopContext } from 'src/hooks/use-shop-context';
import { useSettingsContext } from 'src/components/settings';

// ----------------------------------------------------------------------

export default function StudentLayout({ children }) {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const params = useParams();

    const { shopid } = params;

    const { settings, isLoading } = useSelector((state) => state.shops);
    const themeSettings = useSettingsContext();

    const [value, setValue] = useState(0);

    useEffect(() => {
        if (shopid) {
            dispatch(getShopSettings(shopid));
        }
    }, [dispatch, shopid]);

    useEffect(() => {
        if (location.pathname.includes(`/student/${shopid}/courses`)) {
            setValue(1);
        } else if (location.pathname.includes(`/student/${shopid}/saved`)) {
            setValue(2);
        } else if (location.pathname.includes(`/student/${shopid}/profile`)) {
            setValue(3);
        } else {
            setValue(0);
        }
    }, [location.pathname, shopid]);

    return (
        <ShopContext.Provider value={{ shopid, settings, isLoading }}>
            <Box sx={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                bgcolor: themeSettings.themeBgColor || 'background.default',
                color: themeSettings.themeTextColor || 'text.primary'
            }}>
                <Box component="main" sx={{ flexGrow: 1, pb: 7 }}>
                    {children || <Outlet />}
                </Box>

                <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }} elevation={3}>
                    <BottomNavigation
                        showLabels
                        value={value}
                        onChange={(event, newValue) => {
                            setValue(newValue);
                            switch (newValue) {
                                case 0:
                                    navigate(`/student/${shopid}/dashboard`);
                                    break;
                                case 1:
                                    navigate(`/student/${shopid}/courses`);
                                    break;
                                case 2:
                                    navigate(`/student/${shopid}/saved`);
                                    break;
                                case 3:
                                    navigate(`/student/${shopid}/profile`);
                                    break;
                                default:
                                    break;
                            }
                        }}
                    >
                        <BottomNavigationAction label="Home" icon={<Icon icon={homeFill} width={24} height={24} />} />
                        <BottomNavigationAction label="Courses" icon={<Icon icon={bookOpenFill} width={24} height={24} />} />
                        <BottomNavigationAction label="Saved" icon={<Icon icon="solar:heart-bold" width={24} height={24} />} />
                        <BottomNavigationAction label="Profile" icon={<Icon icon={personFill} width={24} height={24} />} />
                    </BottomNavigation>
                </Paper>
            </Box>
        </ShopContext.Provider>
    );
}

StudentLayout.propTypes = {
    children: PropTypes.node,
};
